import { Platform } from '@ionic/angular';
import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  NavigationExtras,
} from '@angular/router';
import { AuthenticationStore } from '../stores/authentication.store';
@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  constructor(
    private router: Router,
    private authenticationStore: AuthenticationStore,
    public platform: Platform
  ) {}
  canActivate(route: ActivatedRouteSnapshot): boolean {
    // if (!this.authenticationStore.token) {
    //   const navigationExtras: NavigationExtras = {
    //     state: {
    //       onLoad: true,
    //     },
    //   };
    //   this.router.navigate(['/login-page'], navigationExtras);
    //   return false;
    // }
    return true;
  }
}
